import React from 'react'
import SkeletonTile from '../SkeletonTile/SkeletonTile'
import './ContentTypeSkeleton.css'

export type contentTypeSkeletonProps = {
  testId?: string
}

const ContentTypeSkeleton = (props: contentTypeSkeletonProps) => {

  const {
    testId = 'cs-content-type-skeleton'
  } = props

  return (
    <div data-test-id={testId} className="ContentTypeSkeleton">
      <div className="ContentTypeSkeleton__aside">
        <div className="ContentTypeSkeleton__controls">
          <div className="ContentTypeSkeleton__control">
            <SkeletonTile
              numberOfTiles={1}
              tileHeight={12}
              tileWidth={12}
              tileBottomSpace={0}
              tileTopSpace={0}
              tileleftSpace={0}
              tileRadius={4}></SkeletonTile>
          </div>
          <div className="ContentTypeSkeleton__control">
            <SkeletonTile
              numberOfTiles={1}
              tileHeight={12}
              tileWidth={12}
              tileBottomSpace={0}
              tileTopSpace={0}
              tileleftSpace={0}
              tileRadius={4}></SkeletonTile>
          </div>
          <div className="ContentTypeSkeleton__control">
            <SkeletonTile
              numberOfTiles={1}
              tileHeight={12}
              tileWidth={12}
              tileBottomSpace={0}
              tileTopSpace={0}
              tileleftSpace={0}
              tileRadius={4}></SkeletonTile>
          </div>
          <div className="ContentTypeSkeleton__control">
            <SkeletonTile
              numberOfTiles={1}
              tileHeight={12}
              tileWidth={12}
              tileBottomSpace={0}
              tileTopSpace={0}
              tileleftSpace={0}
              tileRadius={4}></SkeletonTile>
          </div>
          <div className="ContentTypeSkeleton__control">
            <SkeletonTile
              numberOfTiles={1}
              tileHeight={12}
              tileWidth={12}
              tileBottomSpace={0}
              tileTopSpace={0}
              tileleftSpace={0}
              tileRadius={4}></SkeletonTile>
          </div>
          <div className="ContentTypeSkeleton__control">
            <SkeletonTile
              numberOfTiles={1}
              tileHeight={12}
              tileWidth={12}
              tileBottomSpace={0}
              tileTopSpace={0}
              tileleftSpace={0}
              tileRadius={4}></SkeletonTile>
          </div>
        </div>
      </div>
      <div className="ContentTypeSkeleton__items">
        <div className="ContentTypeSkeleton__item">
          <div className="ContentTypeSkeleton__entry">
            <div className="ContentTypeSkeleton__icon">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__title">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={12}
                tileWidth={270}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={10}></SkeletonTile>
            </div>
          </div>
          <div className="ContentTypeSkeleton__options">
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
          </div>
        </div>
        <div className="ContentTypeSkeleton__item">
          <div className="ContentTypeSkeleton__entry">
            <div className="ContentTypeSkeleton__icon">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__title">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={12}
                tileWidth={100}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={10}></SkeletonTile>
            </div>
          </div>
          <div className="ContentTypeSkeleton__options">
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
          </div>
        </div>
        <div className="ContentTypeSkeleton__item">
          <div className="ContentTypeSkeleton__entry">
            <div className="ContentTypeSkeleton__icon">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__title">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={12}
                tileWidth={178}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={10}></SkeletonTile>
            </div>
          </div>
          <div className="ContentTypeSkeleton__options">
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
          </div>
        </div>
        <div className="ContentTypeSkeleton__item">
          <div className="ContentTypeSkeleton__entry">
            <div className="ContentTypeSkeleton__icon">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__title">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={12}
                tileWidth={100}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={10}></SkeletonTile>
            </div>
          </div>
          <div className="ContentTypeSkeleton__options">
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
          </div>
        </div>
        <div className="ContentTypeSkeleton__item">
          <div className="ContentTypeSkeleton__entry">
            <div className="ContentTypeSkeleton__icon">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__title">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={12}
                tileWidth={136}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={10}></SkeletonTile>
            </div>
          </div>
          <div className="ContentTypeSkeleton__options">
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
          </div>
        </div>
        <div className="ContentTypeSkeleton__item">
          <div className="ContentTypeSkeleton__entry">
            <div className="ContentTypeSkeleton__icon">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__title">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={12}
                tileWidth={70}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={10}></SkeletonTile>
            </div>
          </div>
          <div className="ContentTypeSkeleton__options">
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
            <div className="ContentTypeSkeleton__option">
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={18}
                tileWidth={18}
                tileBottomSpace={0}
                tileTopSpace={0}
                tileleftSpace={0}
                tileRadius={4}></SkeletonTile>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentTypeSkeleton
